import { CSSProperties } from "react";
import styled, { css } from "styled-components";
import StyledReactModal from "styled-react-modal";

type StyledReactModalDefault = {
  default: typeof StyledReactModal;
};

type StyledModalProps = {
  position?: CSSProperties["position"];
  alignment?: "center" | "top" | "bottom";
  top?: CSSProperties["top"];
  left?: CSSProperties["left"];
};

const getStyledReactModal = () => {
  if (Object.keys(StyledReactModal).includes("default")) {
    return (StyledReactModal as unknown as StyledReactModalDefault).default;
  }
  return StyledReactModal;
};

const commonStyles = css`
  display: flex;
  position: ${(props: StyledModalProps) => props?.position || "relative"};
  top: ${(props: StyledModalProps) =>
    props?.top ? props?.top + "px" : "unset"};
  left: ${(props: StyledModalProps) =>
    props?.left ? props?.left + "px" : "unset"};
  flex-direction: column;
  max-width: 80vw;
  max-height: 80vh;
  overflow: hidden;
  background-color: var(--color-neutral-000-full);
  box-shadow: var(--elevation-8);
  border-radius: var(--size-border-radius-medium);
  padding-bottom: 24px;
  align-self: ${(props: StyledModalProps) => {
    const vals: Record<
      "top" | "center" | "bottom",
      CSSProperties["alignSelf"]
    > = {
      top: "flex-start",
      center: "center",
      bottom: "flex-end",
    };
    const alignment = props?.alignment || "center";
    return vals?.[alignment];
  }};

  header {
    max-width: 80%;
  }

  > header:nth-child(2),
  ul:nth-child(2) {
    padding-top: 24px;
  }

  &.no-close-btn > header:first-child,
  &.no-close-btn > ul:first-child {
    padding-top: 22px;
  }

  > *:not(:last-child) {
    padding: 0px 24px 16px 24px;
  }

  > :last-child {
    padding: 24px 24px 0px 24px;
  }

  &.small {
    width: 400px;
  }

  &.medium {
    width: 600px;
  }

  &.large {
    width: 800px;
  }

  &.extra-large {
    width: 1120px;
  }

  &.fullscreen {
    max-width: 100vw;
    width: 100%;
  }
`;

export const StyledModal = getStyledReactModal().styled`
  ${commonStyles}
`;

export const StyledDialogContainer = styled.div`
  ${commonStyles}
`;
